import { TradingOfferStatus } from '../../../types/TradingOffer';

type TradingOfferStatusConfig = {
  label: string;
  value: TradingOfferStatus;
  fill: string;
  style: string;
  badge: string;
  icon: string;
};

const tradingOfferStatus: Record<TradingOfferStatus, TradingOfferStatusConfig> =
  {
    DRAFT: {
      label: 'Draft',
      value: TradingOfferStatus.DRAFT,
      style: 'text-light',
      badge: 'badge badge-outline badge-light',
      fill: 'bg-light',
      icon: 'ni-draft',
    },
    PENDING: {
      label: 'Pending',
      value: TradingOfferStatus.PENDING,
      style: 'text-primary',
      badge: 'badge badge-outline badge-primary',
      fill: 'bg-primary',
      icon: 'ni-clock',
    },
    CANCELED: {
      label: 'Canceled',
      value: TradingOfferStatus.CANCELED,
      style: 'text-danger',
      badge: 'badge badge-outline badge-danger',
      fill: 'bg-danger',
      icon: 'ni-cross-circle',
    },
    ACTIVE: {
      label: 'Active',
      value: TradingOfferStatus.ACTIVE,
      style: 'text-primary',
      badge: 'badge badge-outline badge-primary',
      fill: 'bg-primary',
      icon: 'ni-activity',
    },
    ACCEPTED: {
      label: 'Accepted',
      value: TradingOfferStatus.ACCEPTED,
      style: 'text-success',
      badge: 'badge badge-outline badge-success',
      fill: 'bg-success',
      icon: 'ni-check-circle',
    },
    REJECTED: {
      label: 'Rejected',
      value: TradingOfferStatus.REJECTED,
      style: 'text-danger',
      badge: 'badge badge-outline badge-danger',
      fill: 'bg-danger',
      icon: 'ni-cross-circle',
    },
    EXPIRED: {
      label: 'Expired',
      value: TradingOfferStatus.EXPIRED,
      style: 'text-secondary',
      badge: 'badge badge-outline badge-secondary',
      fill: 'bg-secondary',
      icon: 'ni-clock',
    },
  };

export default tradingOfferStatus;
